<template>
  <RouterView />
</template>

<script setup>
import { useTokenStore } from '@/stores'

const { setToken, setRefreshtoken } = useTokenStore()

onMounted(() => {
  // 获取网址中的token参数的值
  // const token = new URL(window.location.href).searchParams.get('token')
  // const refreshtoken = new URL(window.location.href).searchParams.get('refreshtoken')

  const token =
    'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VySnNvbiI6IntcImlkXCI6NDAsXCJwbGF0Zm9ybUNvbnN0YW50XCI6XCJXRUNIQVRfUFJPR1JBTVwiLFwiZXhwaXJlc0F0XCI6MTc2NjMwNjQwODQxOSxcInJlbWVtYmVyXCI6dHJ1ZX0iLCJleHAiOjE3NjYzMDY0MDh9.IZvS7Xmz_yVkXJ1ZOfwUV4kiRwPQA20NXv2s9bLS0s2OztbkfyfdxFIvKkOEtKmT8M4YwW-Hk3DQQQavXuoA4g'
  const refreshtoken = 'feca5cdbb9448e752a73f7632b3b6b8e'
  console.log("🚀 ~ refreshtoken:", refreshtoken)
  console.log("🚀 ~ token:", token)
  if (token) {
    // 存储token
    localStorage.setItem('userToken', JSON.stringify({ token, refreshtoken }))
    setToken(token)
    setRefreshtoken(refreshtoken)
  }

})
</script>

<style scoped lang="scss"></style>
